import { render, staticRenderFns } from "./amortizfrm.vue?vue&type=template&id=2b547505"
import script from "./amortizfrm.vue?vue&type=script&lang=js"
export * from "./amortizfrm.vue?vue&type=script&lang=js"
import style0 from "./amortizfrm.vue?vue&type=style&index=0&id=2b547505&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports